import { SEOHead } from "@/components/SEOHead";
import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";
import { useLanguage } from "@/contexts/LanguageContext";
import { Button } from "@/components/ui/button";
import { FileText, Download, ClipboardCheck, FileCheck, Truck } from "lucide-react";

const Resources = () => {
  const { t } = useLanguage();

  const resources = [
    {
      icon: FileText,
      link: "https://www.aitiminc.com/_files/ugd/5c8a3f_178c052e9d9e481d999fa0eb8ac26dd3.pdf"
    },
    {
      icon: Truck,
      link: "https://www.aitiminc.com/_files/ugd/5c8a3f_7606f6de786541f2a64bc06e083ee71b.pdf"
    },
    {
      icon: ClipboardCheck,
      link: "https://www.aitiminc.com/_files/ugd/5c8a3f_fb16aca9ac3844119003002978b8efd5.pdf"
    },
    {
      icon: FileCheck,
      link: "https://www.aitiminc.com/_files/ugd/5c8a3f_c043f1d3b5fc45b3ae76276e0d25a8b5.pdf"
    }
  ];

  return (
    <div className="min-h-screen bg-background font-sans">
      <SEOHead 
        title={t('resources.title')}
        description={t('resources.subtitle')}
        canonical="/resources"
      />
      <Navbar />

      <main>
        {/* Hero Section */}
        <section className="bg-navy-950 pt-28 pb-16 md:pt-44 md:pb-28 text-center px-4 relative overflow-hidden">
          {/* Background Elements */}
          <div className="absolute inset-0 z-0 opacity-10">
            <div className="absolute top-0 left-0 w-full h-full bg-[radial-gradient(circle_at_center,_var(--tw-gradient-stops))] from-primary/50 via-transparent to-transparent"></div>
          </div>
          
          <div className="container mx-auto max-w-4xl relative z-10">
            <div className="inline-block px-4 py-1.5 rounded-full bg-primary/20 text-primary font-semibold text-sm mb-6 border border-primary/30 tracking-wide uppercase">
              AITIM GROUP
            </div>
            <h1 className="text-3xl md:text-5xl lg:text-7xl font-black text-white mb-6 tracking-tight uppercase">
              {t('resources.title')}
            </h1>
            <p className="text-xl md:text-2xl text-white/80 font-medium max-w-2xl mx-auto">
              {t('resources.subtitle')}
            </p>
          </div>
        </section>

        {/* Resources Grid Section */}
        <section className="bg-slate-50 py-20 md:py-32">
          <div className="container mx-auto px-4 max-w-7xl">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
              {resources.map((resource, i) => (
                <div key={i} className="bg-white rounded-2xl p-8 md:p-10 shadow-sm border border-slate-200 hover:shadow-xl transition-all duration-300 group flex flex-col md:flex-row gap-8 items-start">
                  <div className="bg-slate-50 p-6 rounded-xl shrink-0 group-hover:bg-primary/5 transition-colors duration-300">
                    <resource.icon className="w-16 h-16 text-primary" strokeWidth={1.5} />
                  </div>
                  <div className="flex flex-col h-full w-full">
                    <h3 className="text-2xl font-bold text-navy-950 mb-4 group-hover:text-primary transition-colors">
                      {t(`resources.items.${i}.title`)}
                    </h3>
                    <p className="text-slate-600 leading-relaxed mb-8 flex-grow">
                      {t(`resources.items.${i}.desc`)}
                    </p>
                    <a href={resource.link} target="_blank" rel="noopener noreferrer" className="mt-auto inline-block w-full md:w-auto">
                      <Button className="bg-navy-950 hover:bg-primary text-white rounded-sm px-8 h-12 w-full transition-all duration-300 group-hover:shadow-lg group-hover:shadow-primary/20">
                        <Download className="mr-2 w-4 h-4" /> {t('resources.downloadBtn')}
                      </Button>
                    </a>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>
      </main>

      <Footer />
    </div>
  );
};

export default Resources;
